import { AuthenticationResult, PopupRequest } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

/**
 * 
 * description
 * 
 * ###Import to use it
 *
 *```jsx
 *   import { AzureOAuthButton } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 *<AzureOAuthButton 
 *   label={string} 
 *   isSubmit={boolean} 
 *   disabled={boolean}
 />
 *```
 *
 *### Basic Example
 */

export const AzureOAuthButton = (props: AzureOAuthButtonProps) =>  {

    const { instance } = useMsal();

    const handleClick = async () => {
        props.onClick?.()
        try {
            const result = await instance.loginPopup(props.loginRequest)
            props.onSucess?.(result)
        } catch (e) {
            props.onError?.(e)
        }
    }

    if (props.renderer) {
        return (
            <div onClick={handleClick}>
                { props.renderer() }
            </div>
        )
    }

    return (
        <button className="sbtn-icon" onClick={handleClick}>
            <img src="/assets/img/microsoft.svg" alt="google" />
        </button>
    )
}

AzureOAuthButton.defaultProps = {
    loginRequest: {
        scope: ["User.Read"]
    } 
}

export type AzureOAuthButtonProps = {
    loginRequest: PopupRequest,
    onClick?: () => void,
    onSucess?: (result: AuthenticationResult) => void
    onError?: (e: any) => void,
    renderer?: () => JSX.Element,
} 
